module.exports = __webpack_public_path__ + "static/media/Guanacaste.d1caf512.jpg";